<div class="container-fluid">
     <app-loader [loading]="loading"></app-loader>
    <div class="row">
        <div class="col-xl-12">
            <div class="row">
                @for(stat of statData;track $index){
                <div class="col-md-3">
                    <app-stat [title]="stat.title" [value]="stat.value" [icon]="stat.icon"
                        [navigateUrl]="stat.navigate"></app-stat>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6">
            <div class="card">
                <div class="card-body">
                    <!-- <div class="dropdown float-end" ngbDropdown>
            <button class="btn btn-primary btn-sm" (click)="navigateOnLogs()">View More Logs</button>
          </div> -->

                    <h4 class="card-title mb-4">Recent Activity Feed</h4>

                    <ngx-simplebar style="height: 330px;">
                        <ul class="list-unstyled activity-wid">
                            @for(log of logs; track log;){
                            <li class="activity-list" *ngFor="let log of logs">

                                <div class="activity-icon avatar-xs">
                                    <span class="avatar-title bg-primary-subtle text-primary rounded-circle">
                                        <i class="ri-file-list-3-line"></i> </span>
                                </div>

                                <div>

                                    <!-- Date -->
                                    <div>
                                        <h5 class="font-size-13 mb-1">
                                            {{ log.createdAt | date:'medium' }}
                                        </h5>
                                    </div>

                                    <!-- Dynamic Description -->
                                    <div>
                                        <p class="text-muted mb-0">

                                            <strong>{{ log.method }}</strong>
                                            request to

                                            <span class="text-primary">
                                                {{ log.endpoint }}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="small text-muted d-flex align-items-center gap-3">

                                        <span>
                                            Response Time:
                                            <strong>{{ log.responseTimeMs }} ms</strong>
                                        </span>

                                        <span>
                                            IP: {{ log.ip }}
                                        </span>

                                        <span>
                                            Status: <span [ngClass]="{
            'text-success': log.statusCode < 300,
            'text-warning': log.statusCode >= 300 && log.statusCode < 500,
            'text-danger': log.statusCode >= 500
          }">
                                                {{ log.statusCode }}
                                            </span>
                                        </span>

                                    </div>

                                </div>

                            </li>
                            }
                        </ul>
                    </ngx-simplebar>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="card">
                <div class="card-body">
                    <!-- <h4 class="card-title mb-4">Line with Data Labels</h4> -->
                    <apx-chart class="apex-charts" dir="ltr" [series]="linewithDataChart.series"
                        [chart]="linewithDataChart.chart" [colors]="linewithDataChart.colors"
                        [stroke]="linewithDataChart.stroke" [dataLabels]="linewithDataChart.dataLabels"
                        [title]="linewithDataChart.title" [responsive]="linewithDataChart.responsive"
                        [legend]="linewithDataChart.legend" [xaxis]="linewithDataChart.xaxis"
                        [yaxis]="linewithDataChart.yaxis" [stroke]="linewithDataChart.stroke"
                        [markers]="linewithDataChart.markers">
                    </apx-chart>
                </div>
            </div>
            <!--end card-->
        </div>

        <div class="row">
            <div class="col-8">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4"> Recent Orders</h4>
                        <div *ngIf="loading" class="text-center fw-bold">Loading data...</div>
                        <div class="table-responsive" *ngIf="!loading && orders && orders.length">
                            <table class="table table-centered">
                                <thead class="table-light">
                                    <tr>
                                        <th>Plan</th>
                                        <th>Notes</th>
                                        <th>Payment Mode</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let order of orders; let i = index">
                                        <td>{{ order.planName }}</td>
                                        <td>{{ order.notes }}</td>
                                        <td>{{ order.paymentMethod }}</td>
                                        <td>
                                            <div class="badge font-size-12" [ngClass]="{
                                            'bg-success-subtle text-success': order.status === 'Completed',
                                            'bg-warning-subtle text-warning': order.status === 'Pending',
                                            'bg-danger-subtle text-danger': order.status === 'Cancelled'
                                        }">{{ order.status }}</div>
                                        </td>
                                        <td>{{ order.createdAt | date:'short' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="!loading && (!orders || orders.length === 0)" class="fw-bold text-center">No orders
                            found.</div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="float-end">
                            <select class="form-select" [(ngModel)]="selectedMonth.value"
                                (change)="getMontlyDocStatus()">
                                <option *ngFor="let m of months" [value]="m.value">
                                    {{ m.label }}
                                </option>
                            </select>

                        </div>
                        <h4 class="card-title mb-4">Usage This Month</h4>

                        @if(monthlyData?.length){
                        <apx-chart dir="ltr" class="apex-charts" [series]="salesAnalytics.series"
                            [chart]="salesAnalytics.chart" [labels]="salesAnalytics.labels"
                            [legend]="salesAnalytics.legend" [colors]="salesAnalytics.colors"
                            [dataLabels]="salesAnalytics.dataLabels" [plotOptions]="salesAnalytics.plotOptions"
                            [tooltip]="salesAnalytics.tooltip">
                        </apx-chart>


                        <div class="row">
                            @for(data of monthlyData; track data){
                            <div class="col-4">
                                <div class="text-center mt-3">
                                    <p class="mb-2 text-truncate"><i
                                            class="mdi mdi-circle text-primary font-size-10 me-1" [ngClass]="{
                     'text-primary': data.status === 'Pending',
                     'text-success': data.status === 'Signed',
                     'text-warning': data.status === 'Cancelled'
                   }"></i> {{data.status}}
                                    </p>
                                    <h5>{{data.count}}</h5>
                                </div>
                            </div>
                            }
                        </div>
                        }@else{
                        <div class="text-center fw-bold">No data available.</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>